import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiSearch, FiTarget, FiTrendingUp, FiBarChart2, FiCheckCircle } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import seoHero from "../assets/seo-hero.jpg";

const seoItems = [
  "Technical SEO Audits & Fixes",
  "On-Page Optimization (Title, Meta, Schema)",
  "Off-Page SEO & Link Building",
  "Local SEO (UAE Focused)",
  "Content & Keyword Strategy",
  "Core Web Vitals Optimization",
];

const ppcItems = [
  "Google Ads Campaign Management",
  "YouTube Video Advertising",
  "Meta Ads (Facebook & Instagram)",
  "LinkedIn Advertising",
  "Conversion Rate Optimization",
  "Landing Page Design & A/B Testing",
];

const SEOPerformanceMarketing = () => {
  return (
    <>
      <HeroBanner
        image={seoHero}
        title="SEO & Performance Marketing"
        subtitle="ROI-focused SEO and paid campaigns engineered for leads, conversions, and long-term growth."
      />

      <SectionWrapper>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiSearch className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">SEO <span className="text-primary">Services</span></h2>
            <ul className="space-y-3">
              {seoItems.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiCheckCircle className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
            <FiTarget className="w-12 h-12 text-primary mb-4" />
            <h2 className="text-2xl md:text-3xl font-montserrat font-bold mb-6">PPC & Paid <span className="text-primary">Campaigns</span></h2>
            <ul className="space-y-3">
              {ppcItems.map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <FiTrendingUp className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="font-roboto text-muted-foreground">{item}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Boost Your Rankings Today</h2>
        <Link to="/contact" className="btn-hero-outline">Get Free SEO Audit</Link>
      </SectionWrapper>
    </>
  );
};

export default SEOPerformanceMarketing;
